var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticStyle: { "z-index": "99990" },
      attrs: {
        "button-close-hidden": "",
        title: _vm.title,
        active: _vm.$store.state.submit_visibility
      },
      on: {
        "update:active": function($event) {
          return _vm.$set(_vm.$store.state, "submit_visibility", $event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("vx-card", { attrs: { title: _vm.title } }, [
            _c(
              "form",
              [
                _c("div", { staticClass: "vx-col w-full" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.text) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-col w-full" }, [
                  _c("form", [
                    _c("div", { staticClass: "vx-row" }, [
                      _c(
                        "div",
                        { staticClass: "vx-col w-full" },
                        [
                          _c("vs-input", {
                            staticClass: "mt-3 w-full",
                            attrs: {
                              placeholder: "Remarks ...",
                              label: "Remarks",
                              name: "Remarks"
                            },
                            on: { input: _vm.onTypeRemarks },
                            model: {
                              value: _vm.admin_note,
                              callback: function($$v) {
                                _vm.admin_note = $$v
                              },
                              expression: "admin_note"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.error_msg
                        ? _c(
                            "div",
                            { staticClass: "vx-col w-full mt-2" },
                            [
                              _c(
                                "vs-alert",
                                {
                                  attrs: {
                                    color: "danger",
                                    icon: "new_releases"
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.error_msg))])]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("vs-divider", { staticClass: "mb-base" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass: "mt-5",
                        attrs: { type: "flat" },
                        on: {
                          click: function($event) {
                            return _vm.onClickGoBackRemarkPopUp()
                          }
                        }
                      },
                      [_vm._v("GO BACK")]
                    ),
                    _vm._v(" "),
                    _c(
                      "vs-button",
                      {
                        staticClass: "mt-5",
                        attrs: { type: "gradient", color: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onClickSubmitRemarkPopup()
                          }
                        }
                      },
                      [_vm._v("SUBMIT")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }